import { createLucideIcon } from 'lucide-react'
import NutritionStockButton, { StockBadge } from './NutritionStockButton'
import { consistencyLabel, formatPlateItem } from './nutritionFormat'

const Move = createLucideIcon('move', [
  ['path', { d: 'M12 2v20' }],
  ['path', { d: 'm15 19-3 3-3-3' }],
  ['path', { d: 'm19 9 3 3-3 3' }],
  ['path', { d: 'M2 12h20' }],
  ['path', { d: 'm5 9-3 3 3 3' }],
  ['path', { d: 'm9 5 3-3 3 3' }]
])

function NutritionPrescriptions({ active, suspended, canEdit, canStock, canSee, onEdit, onSuspend, onReload }) {
  const stockItems = [...active, ...suspended].filter((item) => item.track_stock)
  return (
    <div className="nut-side">
      {canSee && (
        <section className="med-medical" data-onboarding="nutrition-plates">
          <div className="med-medical-head">
            <h3>Prescrições nutricionais ativas</h3>
          </div>
          {!active.length && <p className="patients-muted">Nenhuma refeição ativa. Crie um prato e arraste para a linha do tempo.</p>}
          <div className="nut-rx-grid">
            {active.map((item) => (
              <article
                key={item.id}
                className={`nut-rx-card${canEdit ? ' is-draggable' : ''}`}
                draggable={canEdit}
                onDragStart={(event) => {
                  event.dataTransfer.setData('text/plain', String(item.id))
                  event.dataTransfer.effectAllowed = 'move'
                }}
              >
                <div className="nut-rx-card-head">
                  <p className="med-rx-title">
                    <strong>{item.name}</strong>
                    <span> ({consistencyLabel(item.consistency) || 'Dieta'})</span>
                  </p>
                  {canEdit && <Move size={16} aria-label="Arrastar prato" />}
                </div>
                {item.items?.length > 0 && (
                  <ul className="nut-plate">
                    {item.items.map((food, index) => <li key={`${index}-${food.food_name}`}>{formatPlateItem(food)}</li>)}
                  </ul>
                )}
                <p className="patients-muted nut-rx-note">{item.notes || 'Sem observação'}</p>
                <p className="patients-muted">Responsável: {item.prescribed_by_name || 'não informado'}</p>
                {canEdit && (
                  <div className="med-rx-links">
                    <button type="button" onClick={() => onEdit(item)}>Editar</button>
                    <button type="button" onClick={() => onSuspend(item)}>Suspender</button>
                  </div>
                )}
              </article>
            ))}
          </div>
          {suspended.length > 0 && (
            <div className="med-suspended">
              <h3>Suspensas</h3>
              {suspended.map((item) => (
                <p key={item.id} className="patients-muted">{item.name}{item.suspend_reason ? ` · ${item.suspend_reason}` : ''}</p>
              ))}
            </div>
          )}
        </section>
      )}

      <section className="med-medical" data-onboarding="nutrition-stock">
        <div className="med-medical-head">
          <h3>Estoque de fórmulas e insumos</h3>
        </div>
        {!stockItems.length && <p className="patients-muted">Nenhuma fórmula com estoque controlado.</p>}
        <div className="med-rx-list">
          {stockItems.map((item) => (
            <article key={item.id} className="med-rx-item">
              <div className="med-rx-item-main">
                <p className="med-rx-title"><strong>{item.name}</strong></p>
                <p className="patients-muted">
                  {item.status === 'suspensa' ? 'Suspensa · ' : ''}
                  Alerta a partir de {item.min_stock_alert == null ? '—' : item.min_stock_alert} · consumo {item.dose_amount} por oferta
                </p>
              </div>
              <div className="med-rx-stock">
                <StockBadge item={item} />
                {canStock && <NutritionStockButton onReload={(quantity) => onReload(item, quantity)} />}
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}

export default NutritionPrescriptions
